// extracted by mini-css-extract-plugin
export default {"serialNumberLoader":"SerialNumberLoader_serialNumberLoader__OlfJg"};